<script setup>
import { useStore } from 'vuex'

const userListStore = useUserList()
const { isToastVisible: isVisible, toastData } = storeToRefs(userListStore)
const { hideToast } = userListStore

const store = useStore()
const isPptoToastVisible = computed(() => store.getters.pptoToastModalOpen)
</script>

<template>
  <div class="use-list-toast-container">
    <div
      v-if="isVisible"
      class="user-list-toast"
      :class="{ 'ppto-active': isPptoToastVisible }"
    >
      <div class="toast-content">
        <p v-if="toastData.notificationStatus === 'created'">
          Notification created
        </p>
        <p v-if="toastData.notificationStatus === 'canceled'">
          Notification canceled
        </p>

        <p v-if="toastData.listsAdded > 0">
          Wine added to
          <NuxtLink to="/cellar/lists" @click="hideToast">
            {{ toastData.listsAdded }}
            {{ toastData.listsAdded === 1 ? 'list' : 'lists' }}
          </NuxtLink>
        </p>

        <p v-if="toastData.listsRemoved > 0">
          Wine removed from
          <NuxtLink to="/cellar/lists" @click="hideToast">
            {{ toastData.listsRemoved }}
            {{ toastData.listsRemoved === 1 ? 'list' : 'lists' }}
          </NuxtLink>
        </p>
      </div>
      <button class="close-button" aria-label="Dismiss" @click="hideToast">
        &times;
      </button>
    </div>
  </div>
</template>
